import type { ReactNode } from "react";

export {
  PresentationResult,
  PresentationResultHoldout,
  PresentationResultNoAudienceMatch,
  PresentationResultPaywall,
  PresentationResultPaywallNotAvailable,
  PresentationResultPlacementNotFound,
  PresentationResultUserIsSubscribed,
} from "./presentation-result.web.ts";

/** Web stub — native `SuperwallExpoModule` is unavailable on web/SSR. */
export function SuperwallProvider(props: { children?: ReactNode }) {
  return props.children ?? null;
}

/** Web stub — Superwall currently has no Expo web SDK. */
export function usePlacement() {
  return {
    registerPlacement: async ({
      feature,
    }: {
      feature?: () => void;
      params?: Record<string, unknown>;
      placement: string;
    }): Promise<void> => {
      feature?.();
    },
    state: { status: "idle" as const },
  };
}

/** Web stub — no SDK means no paywall, so no event ever fires. */
export function useSuperwallEvents(_callbacks?: unknown): void {}

const webSuperwallStore = {
  dismiss: async (): Promise<void> => {},
};

/** Web stub — no paywall is ever presented, so there is nothing to dismiss. */
export function useSuperwall<T>(selector: (state: typeof webSuperwallStore) => T): T {
  return selector(webSuperwallStore);
}

/**
 * Web stub — with no SDK there is no store receipt, so report no subscription. Premium on web is
 * decided by the server entitlement (`useIsPremium`); an `ACTIVE` here would also leak into Jest,
 * which resolves this stub while `Platform.OS` reports a native platform.
 */
export function useUser() {
  return {
    getEntitlements: async () => ({ active: [], inactive: [] }),
    getIntegrationAttributes: async () => ({}),
    identify: async () => {},
    refresh: async () => ({}),
    setIntegrationAttributes: async () => {},
    setSubscriptionStatus: async () => {},
    signOut: async () => {},
    subscriptionStatus: { status: "INACTIVE" as const },
    update: async () => {},
    user: null,
  };
}

export default function DefaultSuperwallProvider(props: { children?: ReactNode }) {
  return SuperwallProvider(props);
}
